export default "/images/a41c43b52b895c194b48a7d81982d8fa.avif";